import React, { useEffect, useState } from "react";
import request from "../../../../Helpers/API";
import Swal from "sweetalert2";
import MenusScreen from "./MenusScreen";
import { Settings } from "@mui/icons-material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const ModulosScreen = ({ idusuario }) => {
  const [listadoModulos, setListadoModulos] = useState([]);

  const [menuIdModulo, setMenuIdModulo] = useState(0);
  const [menuTitulo, setMenuTitulo] = useState("");

  const [mostrarMenu, setMostrarMenu] = useState(false);

  useEffect(() => {
    // setLoader({ ...loader, mostrar: true });
    request
      .get(`MenuUsuarios/ListadoModulos`)
      .then((result) => {
        // setLoader({ ...loader, mostrar: false });
        setListadoModulos(result);
      })
      .catch((error) => {
        // setLoader({ ...loader, mostrar: false });
        Swal.fire("Modulos", JSON.stringify(error), "error");
      });
  }, []);

  const onMostrarMenu = (idmodulo, descripcion) => {
    setMostrarMenu(true);
    setMenuIdModulo(idmodulo);
    setMenuTitulo(descripcion);
  };

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };

  return (
    <div className="permisos-usuarios-modulos-main-screen-container">
      <div className="permisos-usuarios-modulos-menu-grid">
        <div className="permisos-usuarios-modulos-container scroll-4">
          {listadoModulos.map((item) => (
            <div
              className="permisos-usuarios-modulos-datos"
              key={item.idmodulo}
            >
              <div className="permisos-usuarios-modulos-titulos">
                <div
                  className="permisos-usuarios-modulos-titulo-container"
                  onClick={() => onMostrarMenu(item.idmodulo, item.descripcion)}
                >
                  <div>
                    <Settings />
                    {capitalizeWords(item.descripcion)}
                  </div>
                  <ArrowForwardIosIcon />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="permisos-usuarios-menu-screen-main">
          {mostrarMenu === true ? (
            <MenusScreen
              setMostrarMenu={setMostrarMenu}
              idmodulo={menuIdModulo}
              descripcion={menuTitulo}
              idusuario={idusuario}
            />
          ) : (
            <div />
          )}
        </div>
      </div>
    </div>
  );
};

export default ModulosScreen;
